<template>
    <component :is="facet.type" :facet="facet" :criteria.sync="boundCriteria" :data-facet-name="facet.name" />
</template>
<script>
import BooleanFacet from './boolean-facet.vue'
import CheckboxFacet from './checkbox-facet.vue'
import RadioFacet from './RadioFacet.vue'
import RangeFacet from './range-facet.vue'
import DateRangeFacet from './date-range-facet.vue'

export default {
    components: {
        boolean: BooleanFacet,
        checkbox: CheckboxFacet,
        'date-range': DateRangeFacet,
        radio: RadioFacet,
        range: RangeFacet,
    },
    props: {
        facet: {
            type: Object,
            required: true,
        },
        criteria: {
            type: Array,
            default() {
                return []
            },
        },
    },
    computed: {
        boundCriteria: {
            get() {
                return this.criteria
            },
            set(value) {
                this.$emit('update:criteria', value)
            },
        },
    },
}
</script>
<style>
.filter-component {
    /* this facet needs to be wider */
    &[data-facet-name='Sector/Industry'] .filter-content {
        width: 400px;
    }
}
</style>
